import React from "react";
type ScreenLogViewProps = React.PropsWithChildren<{}>;
function ScreenLogView(props: ScreenLogViewProps) {
	return <div>Hello ScreenLogView!!</div>;
}

export default ScreenLogView;
